import { observer } from 'mobx-react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import * as Sentry from '@sentry/react';
import MainRouter from './routers/MainRouter';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import { rootStore, StoreProvider } from './stores';
import './environment';

import './i18n';
import theme from './utils/theme';
import ErrorPage from './views/ErrorPage';

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: 'https://6e5e81dc4120712fc4437f0f09bebb34@o151333.ingest.sentry.io/4506557765255168',
    release: `${import.meta.env.npm_package_version || import.meta.env.VITE_VERSION}.${
      import.meta.env.VITE_BUILD_NUMBER
    }`,
    environment: import.meta.env.VITE_ENVIRONMENT,
    tracesSampleRate: 0,
  });
}

const router = createBrowserRouter([
  {
    path: '*',
    element: <MainRouter />,
    errorElement: <ErrorPage />,
  },
]);

const App = observer(() => {
  return (
    <StoreProvider store={rootStore}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          <RouterProvider router={router} />
        </LocalizationProvider>
      </ThemeProvider>
    </StoreProvider>
  );
});

export default App;
